import React, { useState } from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import tw, { css } from 'twin.macro'
import { X, Check, ChevronDown, ChevronUp } from 'react-feather'
import V2Pro from '../../images/MineralSwimV2_Carton+ControlUnit+PRO.png'
import V2Purifier from '../../images/MineralSwimV2_Carton+ControlUnit+PURIFIER.png'
import { Link } from 'gatsby'
export default ({ mineralSwimV2Products = [], id, style, handleSelectProduct, selectedProducts }) => {
	const [specOpen, setSpecOpen] = useState(false)
	const [featOpen, setFeatOpen] = useState(false)
	const [warOpen, setWarOpen] = useState(false)
	const [upgOpen, setUpgOpen] = useState(false)

	// Desired order
	const order = [
		'Mineral Swim PRO40',
		'Mineral Swim PRO25',
		'Mineral Swim PRO20',
		'Mineral Swim Purifier 400VA'
	];

	const products = Array.isArray(mineralSwimV2Products) ? mineralSwimV2Products : [];
	products.sort((a, b) => {
    const aIndex = order.indexOf(a.title);
    const bIndex = order.indexOf(b.title);
    return (aIndex === -1 ? order.length : aIndex) - (bIndex === -1 ? order.length : bIndex);
});

	console.log(products);
return (
		<>
			<p tw="text-xl bg-gray-200 mx-2 my-3 p-2 md:hidden">Mineral Swim<span tw='text-base md:text-base text-black align-text-top'>™</span></p>
			<div tw="overflow-scroll md:overflow-hidden">
				<table id={id} css={style}> 
					<caption>Mineral Swim<span tw='text-base md:text-lg text-black align-text-top'>™</span></caption>
					<thead>
						<tr>
							<th tw="align-bottom text-left md:!text-right" scope="col">
								Maytronics Water <br />
								Treatment Product
							</th>
							{products.map(({ images, title }) => {
								return (
								<th scope="col" tw="text-center">
									<div>
										<GatsbyImage image={images && images[0].gatsbyImageData} />
									</div>
									{title && title.split("Mineral Swim").length>1 ? <>Mineral Swim<span tw='text-sm md:text-sm text-black align-text-top'>™</span> {title.split("Mineral Swim")[1]}</> : <>${title}</>}
								</th>
							)})}
						</tr>
					</thead>
					<tbody>
						<tr>
							<td
								tw="font-semibold"
								scope="row"
								data-label="Maytronics Water Treatment Product"
							>
								PRODUCT CODE
							</td>
							<td >10-110-0011</td>
							<td >10-110-0010</td>
							<td >10-110-0009</td>
							<td >10-110-0014</td>
						</tr>
						<tr>
							<td
								tw="font-semibold"
								scope="row"
								data-label="Maytronics Water Treatment Product"
							>
								RRP
							</td>
							<td >$3,449</td>
							<td >$2,975</td>
							<td >$2,735</td>
							<td >$1,599</td>
						</tr>
						<tr
							tw="cursor-pointer"
							onClick={() => setSpecOpen((prevState) => !prevState)}
							className="trow-title"
						>
							<td
								tw="cursor-pointer font-medium bg-white py-4 uppercase text-lg border-t-2 border-b-2 border-t-gray-400 border-b-gray-400"
								scope="row"
							>
								Specifications
								{specOpen ? (
									<ChevronUp tw="inline-block ml-2 self-center" />
								) : (
									<ChevronDown tw="inline-block ml-2 self-center" />
								)}
							</td>
							<td tw="md:bg-white" colSpan="4" />
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Recommended Max Poolsize
							</td>
							<td >up to 135,000 L</td>
							<td >up to 95,000 L</td>
							<td >up to 75,000 L</td>
							<td >up to 160,000 L</td>
												</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
							Nominal Chlorine Output
							</td>
							<td >39 G/HR + Ozone</td>
							<td >26 G/HR + Ozone</td>
							<td >20 G/HR + Ozone</td>
							<td ></td>
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Ozone Purification
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Mineral/Salt Chlorinator
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
							Modular system with Future Module Upgrades Available
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
							Hand-Held Controller
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
							Generator Module
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
							Purifier Module
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Additional Chlorinator Required
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Compatible with Mineral Swim&trade; Dead Sea Minerals
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Operating Modes
							</td>
							<td >Standard / Eco / Boost</td>
							<td >Standard / Eco / Boost</td>
							<td >Standard / Eco / Boost</td>
							<td >Standard / Eco / Boost</td>
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Operating TDS Level
							</td>
							<td >3500-6500 ppm</td>
							<td >3500-6500 ppm</td>
							<td >3500-6500 ppm</td>
							<td ></td>
						</tr>
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Installation Time
							</td>
							<td>&lt; 1 hour</td>
							<td>&lt; 1 hour</td>
							<td>&lt; 1 hour</td>
							<td>&lt; 1 hour</td>
						</tr>
						{/* <tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Professional Pool Side Health Checks
							</td>
							<td>@ 6-weeks & 6-months</td>
							<td>@ 6-weeks & 6-months</td>
							<td>@ 6-weeks & 6-months</td>
							<td>@ 6-weeks & 6-months</td>
						</tr> */}
						{/* <tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Mineral Swim&trade; Welcome Pack
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
						</tr> */}
						{/* <tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Ecoclear&reg; Shield & Swim, 3 in 1 Pool Water Optimiser
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
						</tr> */}
						<tr css={[!specOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Made in Australia
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr
							tw="cursor-pointer"
							onClick={() => setFeatOpen((prevState) => !prevState)}
							className="trow-title"
						>
							<td
								tw="cursor-pointer font-medium bg-white py-4 uppercase text-lg border-t-2 border-b-2 border-t-gray-400 border-b-gray-400"
								scope="row"
							>
								Features
								{featOpen ? (
									<ChevronUp tw="inline-block ml-2 self-center" />
								) : (
									<ChevronDown tw="inline-block ml-2 self-center" />
								)}
							</td>
							<td tw="md:bg-white" colSpan="4" />
						</tr>
						<tr css={[!featOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Dual Chlorine & Ozone Sanitation
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr css={[!featOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Healthy Pool Water Purification
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr css={[!featOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Allergy, Asthma & Eczema Friendly
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr css={[!featOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Reduced Chlorine & Chemical Usage
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr css={[!featOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Chloramine Removal
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr css={[!featOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Safe Sanitation By-Products
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr css={[!featOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Reduced Eye Irritation
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
						</tr>

						<tr
							tw="cursor-pointer"
							onClick={() => setWarOpen((prevState) => !prevState)}
							className="trow-title"
						>
							<td
								tw="cursor-pointer font-medium bg-white py-4 uppercase text-lg border-t-2 border-b-2 border-t-gray-400 border-b-gray-400"
								scope="row"
							>
								<div>
														<p>Warranty</p>
														<p tw='text-xs normal-case text-gray-700' >For full T&Cs refer to the manual</p>
														</div>

							</td>
							<td tw="align-middle">5 years limited</td>
							<td tw="align-middle">5 years limited</td>
							<td tw="align-middle">5 years limited</td>
							<td tw="align-middle">3 years limited</td>
						</tr>
						{/* <tr css={[!warOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								System (control box, electronics, seals)
							</td>
							<td>5 years (3 years full + 2 years pro rata)</td>
							<td>5 years (3 years full + 2 years pro rata)</td>
							<td>5 years (3 years full + 2 years pro rata)</td>
							<td>5 years (3 years full + 2 years pro rata)</td>
						</tr>
						<tr css={[!warOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Ozone Cell
							</td>
							<td>5 years (3 years full + 2 years pro rata)</td>
							<td>5 years (3 years full + 2 years pro rata)</td>
							<td>5 years (3 years full + 2 years pro rata)</td>
							<td>5 years (3 years full + 2 years pro rata)</td>
						</tr>
						<tr css={[!warOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Electrolyic Cell
							</td>
							<td>5 years (3 years full + 2 years pro rata)</td>
							<td>5 years (3 years full + 2 years pro rata)</td>
							<td>5 years (3 years full + 2 years pro rata)</td>
							<td>-</td>
						</tr> */}

						<tr
							tw="cursor-pointer"
							onClick={() => setUpgOpen((prevState) => !prevState)}
							className="trow-title"
						>
							<td
								tw="cursor-pointer font-medium bg-white py-4 uppercase text-lg border-t-2 border-b-2 border-t-gray-400 border-b-gray-400"
								scope="row"
							>
								Upgrades
								{upgOpen ? (
									<ChevronUp tw="inline-block ml-2 self-center" />
								) : (
									<ChevronDown tw="inline-block ml-2 self-center" />
								)}
							</td>
							<td tw="md:bg-white" colSpan="4" />
						</tr>
						<tr css={[!upgOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								pH Drive Series
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr css={[!upgOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
								Mineral Swim&trade; 100% Dead Sea Minerals
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<Check tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr css={[!upgOpen && tw`!hidden`]}>
							<td tw="font-semibold" scope="row">
							Upgrade to Ozone Purification Available
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
							<td>
								<X tw="mx-auto md:mx-auto" />
							</td>
						</tr>
						<tr>
							<td >
							</td>
							<td className='bg-white'>
								<a href="https://www.maytronics.com.au/product/mineral-swim-pro40/" target='_blank' rel='noopener noreferrer'><button className='font-semibold whitespace-nowrap inline-flex items-center justify-center px-4 py-1 border border-transparent rounded shadow-sm bg-blue-500 hover:bg-blue-400 text-white hover:text-gray-800'>BUY NOW</button></a>
							</td>
							<td className='bg-white'>
								<a href="https://www.maytronics.com.au/product/mineral-swim-pro25/" target='_blank' rel='noopener noreferrer'><button className='font-semibold whitespace-nowrap inline-flex items-center justify-center px-4 py-1 border border-transparent rounded shadow-sm bg-blue-500 hover:bg-blue-400 text-white hover:text-gray-800'>BUY NOW</button></a>
							</td>
							<td className='bg-white'>
								<a href="https://www.maytronics.com.au/product/mineral-swim-pro20/" target='_blank' rel='noopener noreferrer'><button className='font-semibold whitespace-nowrap inline-flex items-center justify-center px-4 py-1 border border-transparent rounded shadow-sm bg-blue-500 hover:bg-blue-400 text-white hover:text-gray-800'>BUY NOW</button></a>
							</td>
							<td className='bg-white'>
								<a href="https://www.maytronics.com.au/product/mineral-swim-ozone-purifier-400va/" target='_blank' rel='noopener noreferrer'><button className='font-semibold whitespace-nowrap inline-flex items-center justify-center px-4 py-1 border border-transparent rounded shadow-sm bg-blue-500 hover:bg-blue-400 text-white hover:text-gray-800'>BUY NOW</button></a>
							</td>
						</tr>
						<tr>
							<td></td>
							<td  className='bg-white'>
								<div className='flex justify-center items-center gap-2'>
							<input type="checkbox" id="v2checkbox1" name="v2checkbox1" className='cursor-pointer' style={{width: '20px', height: '20px', transform: 'scale(1.1)'}} onChange={()=>handleSelectProduct("Mineral Swim™️ V2 PRO40")} checked={selectedProducts.includes("Mineral Swim™️ V2 PRO40")}/>
							<label for="v2checkbox1" className='cursor-pointer'>Compare</label>
							</div>
							</td>
							<td  className='bg-white space-x-2'>

							<div className='flex justify-center items-center gap-2'>
							<input type="checkbox" id="v2checkbox2" name="v2checkbox2" className='cursor-pointer' style={{width: '20px', height: '20px', transform: 'scale(1.1)'}} onChange={()=>handleSelectProduct("Mineral Swim™️ V2 PRO25")} checked={selectedProducts.includes("Mineral Swim™️ V2 PRO25")}/>
							<label for="v2checkbox2" className='cursor-pointer' >Compare</label>
							</div>
							</td>
							<td  className='bg-white space-x-2'>

							<div className='flex justify-center items-center gap-2'>
							<input type="checkbox" id="v2checkbox3" name="v2checkbox3" className='cursor-pointer' style={{width: '20px', height: '20px', transform: 'scale(1.1)'}} onChange={()=>handleSelectProduct("Mineral Swim™️ V2 PRO20")} checked={selectedProducts.includes("Mineral Swim™️ V2 PRO20")}/>
							<label for="v2checkbox3" className='cursor-pointer'>Compare</label>
							</div>
							</td>
							<td  className='bg-white space-x-2'>
							<div className='flex justify-center items-center gap-2'>
							<input type="checkbox" id="v2checkbox4" name="v2checkbox4" className='cursor-pointer' style={{width: '20px', height: '20px', transform: 'scale(1.1)'}} onChange={()=>handleSelectProduct("Mineral Swim™️ V2 Purifer 400VA")} checked={selectedProducts.includes("Mineral Swim™️ V2 Purifer 400VA")}/>
							<label for="v2checkbox4" className='cursor-pointer'>Compare</label>
							</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</>
	)
}
